import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {ChatUtils} from '@extensions/chat-utils'
import {PageService} from '@extensions/page-service'
import {idTasksApi} from './id-tasks-store'

// update link from old format to new format
const handler = (): void => {
  const hash = PageService.getHash()
  if (!hash.includes('chat:')) {
    return
  }

  const shortId = hash.split('chat:').pop()?.split(',').shift()
  if (!shortId) {
    return
  }
  const task = Sync.getCurrentSandbox()?.findByShortId(shortId) as Hub
  if (!task) {
    return
  }
  const idTask = idTasksApi.getIdTask(task.id)
  if (idTask) {
    ChatUtils.openChat(task, {stayClosed: true})
  }
}

export const reopenChat = (timeout = 0): void => {
  setTimeout(handler, timeout)
}
